import { Box, Grid, Skeleton } from '@mui/material';
import NoData from '@root/components/common/NoData';
import ContentBox from '@root/components/v2/content/ContentBox';
import RiskTrendChart from './chart/RiskTrendChart';
// import TopOpenTooltip from '@root/components/v2/ui-elements/Tooltip/TopOpenTooltip';
import moment from 'moment';
// import Loader from '@root/components/common/Loader';
import { isEmpty } from 'lodash';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@root/components/v3/select';

const timeFilterOptions = [
  { label: '7d', value: 7 },
  { label: '30d', value: 30 },
  { label: '90d', value: 90 },
];

const WorkloadCVETrend = props => {
  const { resource_trend, isFetchingResourceTrend, WorkloadTimeRangeValue, setWorkloadTimeRangeValue } = props;

  let ChartData = !isEmpty(resource_trend?.data)
    ? resource_trend?.data?.data_points?.map(item => ({
        date: moment(item.date ? item.date : moment()).format('D MMM'),
        unique_cves: item.unique_cves,
      }))
    : [];
  return (
    <>
      <Grid item>
        <ContentBox
          title={'Workload CVE Trend'}
          titleSize="medium"
          height={'328px'}
          padding="0px"
          titleContainerStyle={{
            // border: "0px",
            fontSize: '16px !important',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            // borderBottom: '1px solid #CBD5E0',
            padding: '11.04px 15px',
            margin: '0px',
          }}
          containerClassName={'border-box-no-pad'}
          paddingMode="content"
          headerEndElement={
            <div className="HeaderContent__Container">
              <Select value={WorkloadTimeRangeValue} onValueChange={v => setWorkloadTimeRangeValue(v)}>
                <SelectTrigger
                  className="h-8 min-w-[140px]"
                  data-testid="workload-cve-trend-time-filter"
                  data-clickable="true">
                  <SelectValue>
                    {WorkloadTimeRangeValue ? `Time Range: ${WorkloadTimeRangeValue}d` : `Time Range: 7d`}
                  </SelectValue>
                </SelectTrigger>
                <SelectContent>
                  {timeFilterOptions?.map(option => (
                    <SelectItem
                      data-testid={`workload-cve-trend-time-filter-item-${option.value}`}
                      data-clickable="true"
                      key={option.value}
                      value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          }>
          {isEmpty(resource_trend?.data) ||
          resource_trend?.data?.trend_data?.length === 0 ||
          resource_trend?.data?.type_breakup?.length === 0 ? (
            <NoData message="No resource trend data present!" height={'350px'} />
          ) : isFetchingResourceTrend ? (
            <Box display="flex" flexDirection="column" alignItems="center" padding="15px">
              <Box width="100%" display="flex" justifyContent="center" marginBottom={'20px'}>
                <Skeleton
                  variant="rectangular"
                  height="250px"
                  sx={{ width: '100%', flexGrow: 1, borderRadius: '8px' }}
                />
              </Box>
            </Box>
          ) : (
            <div className="inventory_new" style={{ padding: '15px' }}>
              <Grid
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '27px',
                }}>
                <RiskTrendChart ChartData={ChartData} />
              </Grid>
            </div>
          )}
        </ContentBox>
      </Grid>
    </>
  );
};

export default WorkloadCVETrend;
